import styles from './index.module.less';
import { useState } from 'react';
import Image from 'next/image';
const Index = ({ price, alternativeBasic, websiteBasic, confirm }: any) => {
  const [number, setNumber] = useState(1);

  return (
    <div className={styles.container}>
      <div className={styles.left}>
        <div className={styles.subTitle}>
          <span>{price.subTitle}</span>
        </div>
        <div className={styles.title}>{price.title}</div>
        <div className={styles.description}>{price.desc}</div>
        <div className={styles.desc2}>{price.desc2}</div>
        <div className={styles.btn} onClick={confirm}>
          {price.actionLabel}
        </div>
      </div>
      <div className={styles.right}>
        <div className={styles.row1}>
          <div>Number of accounts</div>
          <div>
            <div
              className={number >= 1 ? styles.active : ''}
              onClick={() => {
                if (number > 1) {
                  setNumber(number - 1);
                }
              }}
            >
              –
            </div>
            <div>
              <input
                type="number"
                value={number}
                onChange={(e) => {
                  if (Number(e.target.value) < 1) {
                    setNumber(1);
                  } else if (Number(e.target.value) > 100) {
                    setNumber(100);
                  } else {
                    setNumber(Number(e.target.value));
                  }
                }}
              />
            </div>
            <div
              className={number <= 100 ? styles.active : ''}
              onClick={() => {
                if (number < 100) {
                  setNumber(number + 1);
                }
              }}
            >
              +
            </div>
          </div>
        </div>
        <div className={styles.row2}>
          <div>
            <Image src={websiteBasic.imgPath} alt={websiteBasic.imgAlternativeText} width={100} height={31} />
            <div className={styles.price}>
              <span>$</span>
              <span>/mo</span>
              <span>{websiteBasic.price}</span>
            </div>
            <div>
              <span>Unlimited</span>
              <span>Username</span>
            </div>
          </div>
          <div>
            <Image src={alternativeBasic.imgPath} alt={alternativeBasic.imgAlternativeText} width={100} height={31} />
            <div className={styles.price}>
              <span>$</span>
              <span>/mo</span>
              <span>{Number(alternativeBasic.price) * number}</span>
            </div>
            <div>
              <span>{number}</span>
              <span>Username</span>
            </div>
          </div>
        </div>
        <div className={styles.rows3} onClick={confirm}>
          {price.actionLabel}
        </div>
      </div>
    </div>
  );
};

export default Index;
